export default __webpack_public_path__ + "static/media/PORTADA.1a5352ab.png";